export const teamSection = {
  title: 'Команда форума',
  description: 'Эти люди внесли незаменимый вклад в создание форума',
  members: [
    {
      name: 'Юлия Малышева',
      role: 'Организатор',
      company: 'Yula Studio',
      companyHref: 'https://max.ru/id540324189394_biz',
      imageSrc: '/images/team-photo-yulia-malysheva.png',
      imagePosition: 'center top',
      imageHeight: '200%',
      imageTop: '-0.14%',
      imageLeft: '-0.2%',
      mobileOrder: 2
    },
    {
      name: 'Александр Карпович',
      role: 'Бренд-менеджер',
      company: 'ITDesign',
      imageSrc: '/images/team-photo-alexander-karpovich.png',
      imagePosition: 'center center',
      mobileOrder: 4
    },
    {
      name: 'Алексей Снегирев',
      role: 'Технический лидер',
      company: 'aIDATA',
      imageSrc: '/images/team-photo-alexey-snegirev.png',
      imagePosition: 'center top',
      imageHeight: '124.98%',
      imageTop: '0.54%',
      imageLeft: '-0.2%',
      mobileOrder: 5
    }
  ]
};
